import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clientType", "personField", "companyField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.clientTypeTarget.value

    const isPerson = type === "person"
    const isCompany = type === "company"

    this.personFieldTargets.forEach((element) => {
      element.classList.toggle("d-none", !isPerson)
      this.toggleInputs(element, isPerson)
    })

    this.companyFieldTargets.forEach((element) => {
      element.classList.toggle("d-none", !isCompany)
      this.toggleInputs(element, isCompany)
    })
  }

  selectType(event) {
    this.clientTypeTarget.value = event.params.type
    event.currentTarget.closest(".nav").querySelectorAll(".nav-link").forEach(el => el.classList.remove("active"))
    event.currentTarget.classList.add("active")
    this.toggle()
  }

  toggleInputs(container, enabled) {
    container.querySelectorAll("input, select, textarea").forEach((input) => {
      input.disabled = !enabled
    })
  }
}